export default {
  SET_BANNER: "SET_BANNER",
  SET_BANNER_AS_DISSMISSED: "SET_BANNER_AS_DISSMISSED",
};
